import ParametersTab from './ParametersTab';
import { useState } from 'react';
import { Building2, Radio, SlidersHorizontal, Tags, Users, Sparkles } from 'lucide-react';
import UsersTab from './UsersTab';
import InvestorUsersTab from './InvestorUsersTab';
import TagsTab from './TagsTab';
import AISettingsTab from './AISettingsTab';
import SolarModulesTab from './SolarModulesTab';
import EkkDeviceTypesTab from './EkkDeviceTypesTab';
import { useI18n } from '@/i18n';

const TAB_IDS = ['users', 'investor-users', 'solar-modules', 'ekk-definitions', 'tags', 'settings', 'parameters'] as const;
type TabId = typeof TAB_IDS[number];

export default function ManagementPage() {
  const { t } = useI18n();
  const [tab, setTab] = useState<TabId>('users');

  const tabs: Array<{ id: TabId; label: string; icon: React.ReactNode }> = [
    { id: 'users', label: t('management.tabs.users'), icon: <Users size={15} /> },
    { id: 'investor-users', label: 'Yatırımcı Kullanıcıları', icon: <Building2 size={15} /> },
    { id: 'solar-modules', label: 'Panel Modelleri', icon: <SlidersHorizontal size={15} /> },
    { id: 'ekk-definitions', label: 'EKK Tanımları', icon: <Radio size={15} /> },
    { id: 'tags', label: t('management.tabs.tags'), icon: <Tags size={15} /> },
    { id: 'settings', label: t('management.tabs.settings'), icon: <Sparkles size={15} /> },
    { id: 'parameters', label: t('management.tabs.parameters'), icon: <SlidersHorizontal size={15} /> },
  ];

  return (
    <div className="flex h-full flex-col gap-4">
      <div className="flex shrink-0 gap-1 overflow-x-auto border-b border-gray-200">
        {tabs.map((item) => (
          <button
            key={item.id}
            onClick={() => setTab(item.id)}
            className={`-mb-px flex items-center gap-1.5 border-b-2 px-4 py-2 text-sm font-medium transition-colors ${
              tab === item.id
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
            }`}
          >
            {item.icon}
            {item.label}
          </button>
        ))}
      </div>

      <div className="flex min-h-0 flex-1 flex-col">
        {tab === 'users' && <UsersTab />}
        {tab === 'investor-users' && <InvestorUsersTab />}
        {tab === 'solar-modules' && <SolarModulesTab />}
        {tab === 'ekk-definitions' && <EkkDeviceTypesTab />}
        {tab === 'tags' && <TagsTab />}
        {tab === 'settings' && (
          <AISettingsTab />
        )}
        {tab === 'parameters' && <ParametersTab />}
      </div>
    </div>
  );
}
